<template>
	<v-select
		:filterable="false"
		:options="users"
		@search="searchUsers"
		label="name"
		@input="emitUser"
		:value="value"
		:multiple="multiple"
		:placeholder="placeholder"
		:disabled="disabled"
	>
		<template slot="no-options">
			<span>Type to search users...</span>
		</template>

		<template slot="option" slot-scope="option">
			<div v-if="option.name">
				<span>{{ option.name }}</span>
			</div>
		</template>

		<template slot="selected-option" slot-scope="option">
			<span>{{ option.name }}</span>
		</template>
	</v-select>
</template>

<style scoped>
</style>

<script>
import UserService from "@/services/UserService";
import fs from "@/services/FormatService";

export default {
	name: "ConfigUserSearch",

	props: {
		value: true,
		placeholder: true,
		includeTeams: {
			type: Boolean,
			default: false
		},
		supervisorOnly: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		disabled: true
	},

	components: {},

	data() {
		return {
			fs: fs,
			users: []
		};
	},
	created() {},
	watch: {
		value() {
			if (this.value && this.value.length) {
				let seenBefore = {};
				for (let i = 0; i < this.value.length; ) {
					if (this.value[i].users) {
						i++;
					} else {
						let entry = this.value[i];
						if (seenBefore[entry.id]) {
							this.value.splice(i, 1);
						} else {
							seenBefore[entry.id] = true;
							i++;
						}
					}
				}

				for (let i = 0; i < this.value.length; i++) {
					if (this.value[i].users) {
						this.value[i].uniques = 0;
						for (let j = 0; j < this.value[i].users.length; j++) {
							let entry = this.value[i].users[j];
							if (!seenBefore[entry.id]) {
								this.value[i].uniques++;
							}
						}
					}
				}
			}
		}
	},
	computed: {},
	methods: {
		searchUsers(search, loading) {
			loading(true);
			let userCtx = {
				perPage: this.includeTeams ? 5 : 8,
				currentPage: 1,
				active: true,
				filter: search
			};

			UserService.listUsers(userCtx)
				.then(resp => {
					_.each(resp.data.users, user => {
						user.name = fs.nameWithScorerID(user);
					});
					this.users = resp.data.users;

					loading(false);
				})
				.catch(err => {
					console.log(err);
					this.users = [{ name: "Error loading users" }];
				});
		},

		expandTeam(teamID) {
			if (this.value && this.value.length) {
				for (let i = 0; i < this.value.length; ) {
					let entry = this.value[i];
					if (entry.users && entry.id == teamID) {
						this.value.splice(i, 1, ...entry.users);
					} else {
						i++;
					}
				}

				let seenBefore = {};
				for (let i = 0; i < this.value.length; ) {
					let entry = this.value[i];
					if (seenBefore[entry.id]) {
						this.value.splice(i, 1);
					} else {
						seenBefore[entry.id] = true;
						i++;
					}
				}
			}
		},

		emitUser(user) {
			if (!user) {
				this.users = [];
			}
			this.$emit("input", user);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/ConfigUserSearch.vue